import React, { useEffect, useContext } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { ProspectRegistrationDrawerContext } from 'patterns/ProspectRegistrationDrawer/ProspectRegistrationDrawerContext';

import ContentTextEmail from '../ContentTextEmail/ContentTextEmail';

import FeedbackEmailIcon from './components/FeedbackEmailIcon/FeedbackEmailIcon';
import { Container } from './styles/Container';
import { Header, Title } from './styles/Header';

function FeedbackEmail({ email, isOpenForm }) {
  const widget = useContext(ProspectRegistrationDrawerContext);

  useEffect(() => {
    widget.toggleTheme('light');
  }, []);

  return (
    <Container isOpenForm={isOpenForm}>
      <Header gutterBottom={2}>
        <FeedbackEmailIcon />
        <Title
          color="black"
          colorVariant="light"
          intlKey="COMMON.WIDGET.REALTIME_EMAIL.TITLE"
        />
      </Header>
      <FormattedMessage id="COMMON.WIDGET.REALTIME_EMAIL.TEXT">
        { ([txt]) => (
          <ContentTextEmail
            text={txt}
            email={email}
          />
        )}
      </FormattedMessage>
    </Container>
  );
}

FeedbackEmail.defaultProps = {
  isOpenForm: false,
};

FeedbackEmail.propTypes = {
  email: PropTypes.string.isRequired,
  isOpenForm: PropTypes.bool,
};

export default FeedbackEmail;
